import { useEffect, useState } from 'react';

import { THINKING_WORDS, THINKING_WORD_ROTATION_MS } from './MessagesContainer.constants';

/**
 * Picks a random index into {@link THINKING_WORDS}. When `current` is given the
 * result is never `current`, so the label always visibly changes on a tick: it
 * draws from the other `length - 1` indices and shifts past `current`.
 */
const pickRandomWordIndex = (current?: number): number => {
    if (current === undefined || THINKING_WORDS.length < 2) {
        return Math.floor(Math.random() * THINKING_WORDS.length);
    }
    const offset = Math.floor(Math.random() * (THINKING_WORDS.length - 1));
    return offset >= current ? offset + 1 : offset;
};

/**
 * Shows a random word from {@link THINKING_WORDS} in the "Thinking" header while
 * an Ask AICA response is pending (RECUR-26853), switching to a different random
 * word every {@link THINKING_WORD_ROTATION_MS}. The order is random by design,
 * including the first word.
 *
 * The caller mounts this only while a response is pending, so mount/unmount is
 * the lifecycle: the interval starts on mount and is cleared on unmount (the
 * first answer chunk arrived / the turn ended), and each new pending turn starts
 * on a fresh random word.
 */
export function useThinkingWordRotation(): string {
    const [index, setIndex] = useState(() => pickRandomWordIndex());

    useEffect(() => {
        const id = setInterval(() => {
            setIndex((prev) => pickRandomWordIndex(prev));
        }, THINKING_WORD_ROTATION_MS);

        return () => clearInterval(id);
    }, []);

    return THINKING_WORDS[index];
}
